import React from 'react';
import ClientColorCss from '../../../ClientColorCss/ClientColorCss';
export default function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(ClientColorCss, null, function (_ref2) {
    var linkColorPrimary = _ref2.linkColorPrimary,
      trimColorSecondary = _ref2.trimColorSecondary;
    return "\n\t\t\t\t\t.".concat(className, " span span { \n\t\t\t\t\t\tcolor: ").concat(linkColorPrimary, ";\n\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t}\n\t\t\t\t\t.").concat(className, " span span:hover {\n\t\t\t\t\t\t color: ").concat(trimColorSecondary, ";\n\t\t\t\t\t}\n\t\t\t\t\t.").concat(className, ":hover {\n\t\t\t\t\t\t color: ").concat(trimColorSecondary, ";\n\t\t\t\t\t}\n\t\t\t\t");
  });
}